module.exports = __webpack_public_path__ + "img/2.4ddd2d21.png";